/* global window */
import React from 'react';
import { Provider } from 'react-redux';
import {
    BrowserRouter as Router,
    Route,
    browserHistory as history,
    Switch,
    Redirect
} from 'react-router-dom';
import { ThemeProvider, brightTheme } from '@3plearning/react-components';

import { I18nProvider } from '@lingui/react';

import '../../styles/core.scss';
import css from './entry-app.scss';

import BasicApp from './basic-app';

import ErrorHandling from '../../helpers/error-handling';
import {
    ACTIVITY_MASTERY_PATH,
    LIVE_MATHS_PATH,
    PARTICIPATION_PATH,
    SKILL_QUESTS_MASTERY_PATH
} from '../../helpers/constants';
import EMPTY_STATE_VARIANTS from '../../components/empty-state/empty-state-constants';
import SessionIdHelper from '../../helpers/sessionid-helper';

import ConnectedModalContainer from '../modal-container/modal-container';
import ConnectedAnalyticsTracker from '../../components/analytics-tracker/analytics-tracker';
import ConnectedBusyIndicator from '../../components/busy-indicator/busy-indicator';
import ConnectedActivityMastery from '../activity-mastery/activity-mastery';
import ConnectedParticipation from '../participation/participation';
import LiveMaths from '../live-maths/live-maths';
import ConnectedSkillQuestsMastery from '../skill-quests-mastery/skill-quests-mastery';
import ConnectedParticipationFooter from '../../components/participation-footer/participation-footer';
import PageHeader from '../../components/page-header/page-header';
import ConnectedEmptyState from '../../components/empty-state/empty-state';
import DisplayControlContainer from '../../components/display-control-container/display-control-container';

export default class EntryApp extends BasicApp {
    render(store, i18n) {
        // When executing on demo, QA, or production, the host app will inject a property
        // called pppAppConfig into the global window variable.  This will provide the
        // base name of the app.  Most of the time that will be an empty string, but in
        // case it is not, we will extract it and pass it to the router, below.
        // eslint-disable-next-line no-underscore-dangle
        const appConfig = window._env_;
        const BASE_NAME = appConfig ? appConfig.BaseName : '';

        // Add an interceptor to handle errors when accessing resources
        ErrorHandling.addResourceResponseErrorInterceptor(store.dispatch);
        // Add request & response interceptors for session id
        SessionIdHelper.addInterceptors(store);

        return (
            <I18nProvider i18n={i18n}>
                <Provider store={store}>
                    <ThemeProvider
                        theme={{
                            ...brightTheme,
                            overrides: {
                                modal: {
                                    width: '50%',
                                    maxWidth: '600px',
                                    borderRadius: '20px'
                                },
                                footer: {
                                    spacing: 10
                                }
                            }
                        }}
                    >
                        <Router history={history} basename={BASE_NAME}>
                            <div className={css.app}>
                                <ConnectedAnalyticsTracker />
                                <ConnectedEmptyState
                                    variant={EMPTY_STATE_VARIANTS.NO_CLASSES}
                                >
                                    <ConnectedBusyIndicator />
                                    <PageHeader />
                                    <DisplayControlContainer>
                                        <Switch>
                                            <Route
                                                path={ACTIVITY_MASTERY_PATH}
                                                component={
                                                    ConnectedActivityMastery
                                                }
                                            />
                                            <Route
                                                path={LIVE_MATHS_PATH}
                                                component={LiveMaths}
                                            />
                                            <Route
                                                path={PARTICIPATION_PATH}
                                                component={
                                                    ConnectedParticipation
                                                }
                                            />
                                            <Route
                                                path={SKILL_QUESTS_MASTERY_PATH}
                                                component={
                                                    ConnectedSkillQuestsMastery
                                                }
                                            />
                                            <Redirect
                                                from="*"
                                                to={PARTICIPATION_PATH}
                                            />
                                        </Switch>
                                    </DisplayControlContainer>
                                    <ConnectedParticipationFooter
                                        className={css.footer}
                                    />
                                    <ConnectedModalContainer />
                                </ConnectedEmptyState>
                            </div>
                        </Router>
                    </ThemeProvider>
                </Provider>
            </I18nProvider>
        );
    }
}

window.EntryApp = EntryApp;



// WEBPACK FOOTER //
// ./containers/app/entry-app.js